import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getDefaultMobileWidth } from '../../custom-hooks/screen-detector';

import { sanitizeThemeStyleByNumber } from '../../helpers/style';

const ProductImageCon = styled.div`
  display: flex;
  padding: ${props => props.padding};
  margin: ${props => props.margin};
  min-width: ${props => props.width};
  min-height: ${props => props.height};
  @media (max-width: ${getDefaultMobileWidth()}px) {
    min-width: ${props => props.mobileWidth};
    min-height: ${props => props.mobileHeight};
  }

  img {
    ${props =>
      props.isBordered
        ? `
    border: ${props.borderWidth}px solid ${props.borderColor};`
        : ''};

    width: ${props => props.width};
    height: ${props => props.height};
    border-radius: ${props => props.borderRadius}px;
    object-fit: cover;
    cursor: ${props => props.cursor};
    @media (max-width: ${getDefaultMobileWidth()}px) {
      width: ${props => props.mobileWidth};
      height: ${props => props.mobileHeight};
    }
    max-width: 100%;
    max-height: 100%;
    opacity: 1;
  }
`;

export const ProductImage = props => {
  const {
    src,
    width,
    height,
    onImageClick,
    mobileWidth,
    mobileHeight,
    isBordered,
    borderColor,
    borderWidth,
    borderRadius,
    cursor,
    padding = '0px',
    margin = '0px',
    className = '',
  } = props;

  return (
    <ProductImageCon
      onClick={onImageClick}
      width={sanitizeThemeStyleByNumber(width)}
      height={sanitizeThemeStyleByNumber(height)}
      mobileWidth={sanitizeThemeStyleByNumber(mobileWidth)}
      mobileHeight={sanitizeThemeStyleByNumber(mobileHeight)}
      isBordered={isBordered}
      borderColor={borderColor}
      borderWidth={borderWidth}
      borderRadius={borderRadius}
      cursor={cursor}
      padding={padding}
      margin={margin}
      className={`${className} mr-product-image`}
    >
      <img loading="lazy" src={src} alt="" />
    </ProductImageCon>
  );
};

ProductImage.propTypes = {
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  width: PropTypes.string,
  height: PropTypes.string,
  onImageClick: PropTypes.func,
  mobileWidth: PropTypes.string,
  mobileHeight: PropTypes.string,
  isBordered: PropTypes.bool,
  borderColor: PropTypes.string,
  borderWidth: PropTypes.string,
  borderRadius: PropTypes.string,
  cursor: PropTypes.string,
  padding: PropTypes.string,
  margin: PropTypes.string,
  className: PropTypes.string,
};
